var exports = {
  "b": "xaf9ae18d--31cc24--spinner",
  "u": "xaf9ae18d--31cc24--circle-spin",
};

module.exports = exports;
